import {CmServiceCard} from './CmServiceCard';
export default CmServiceCard;
